// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2G3oV","filesListContainer":"PosDisputesFiles_filesListContainer__28aKp","filesButton":"PosDisputesFiles_filesButton__3gjEk"};